import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/layout/Header";
import Sidebar from "../../components/layout/Sidebar";
import { Link } from "react-router-dom";
import ListDealerForOrder from "../../components/scheduleManagement/ListDealerForOrder";
import DealerOrderListTable from "../../components/scheduleManagement/DealerOrderListTable";
import OrdersListScheduleTable from "../../components/scheduleManagement/OrdersListScheduleTable";
import AllSchedulesComp from "../../components/scheduleManagement/AllSchedulesComp";

const AllOrdersPage = ({ nav }) => {
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userSignIn);
  const { userInfo } = userLogin;
  return (
    <div className={nav.isSidebar}>
      <Header nav={nav} />
      <Sidebar nav={nav} />
      <main className="page-content">
        {/*breadcrumb*/}
        <div className="page-breadcrumb d-none d-sm-flex align-items-center">
          <div className="breadcrumb-title pe-3 text-white">
            Schedule Management
          </div>
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="bx bx-home-alt text-white" />
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  All Orders to Schedule
                </li>
              </ol>
            </nav>
          </div>
        </div>
            {/* Main Content */}
            <div className="container-fluid">
          <div className="row">
            {/* Order List - Left Column */}
            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">Order List</h5>
                </div>
                <div className="card-body" style={{ maxHeight: "80vh", overflowY: "auto" }}>
                  <OrdersListScheduleTable nav={nav} />
                </div>
              </div>
            </div>

            {/* Calendar - Right Column */}
            <div className="col-md-8">
              <div className="card shadow-sm">
                <div className="card-header bg-primary text-white">
                  <h5 className="mb-0">Calendar</h5>
                </div>
                <div className="card-body">
                  <AllSchedulesComp nav={nav} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllOrdersPage;
